import { createSlice } from '@reduxjs/toolkit';
import { sendOrder } from './orderAsyncThunk';
import { MAP_TYPES_OPTIONS } from 'constants/map-types-options';
import * as Utils from 'utils';

export const orderSliceName = 'order';

export const orderInitialState = {
  orderErrors: {},
  orderIsProcessing: false,
  orderInformationIsDisabled: {
    name: false,
    email: false,
    phone: false,
  },
  orderInformationErrors: {},
  orderInformationTempAmazon: [],
  orderInformation: {
    attachments: {
      amazon: [],
      dropbox: []
    },
    checklist: {},
    eta: {
      etaText: '',
      etaIsExists: false
    },
    information: {
      name: '',
      phone: '',
      email: '',
      textarea: '',
      isShowcaseProject: true,
      isConsentProcessing: false,
      isFileLoadingProcessing: false
    },
    total: '',
    gmtOffset: Utils.gmtOffset()
  },
};

export const orderSlice = createSlice({
  name: orderSliceName,
  initialState: orderInitialState,
  reducers: {
    createFilesDropbox: (state, action) => {
      state.orderInformation.attachments.dropbox = [...state.orderInformation.attachments.dropbox, ...action.payload];
      state.orderInformation.attachments.dropbox = Utils.arrayUniqueByKey(state.orderInformation.attachments.dropbox, 'destination');
    },
    deleteFileDropboxByHash: (state, action) => {
      state.orderInformation.attachments.dropbox = state.orderInformation.attachments.dropbox.filter(file => file.hash !== action.payload);
    },
    setOrderAttachmentsAmazon: (state, action) => {
      state.orderInformation.attachments.amazon = [...state.orderInformation.attachments.amazon, ...action.payload];
      state.orderInformation.attachments.amazon = Utils.arrayUniqueByKey(state.orderInformation.attachments.amazon, 'destination');
    },
    deleteFileAmazonByHash: (state, action) => {
      state.orderInformation.attachments.amazon = state.orderInformation.attachments.amazon.filter(file => file.hash !== action.payload);
      state.orderInformationTempAmazon = state.orderInformationTempAmazon.filter(file => file.hash !== action.payload);
    },
    setOrderChecklist: (state, action) => {
      state.orderInformation = {
        ...state.orderInformation,
        checklist: action.payload
          .filter(checklist => checklist.optionsType !== MAP_TYPES_OPTIONS.Text)
          .filter(checklist => checklist.options.some(option => option.isChecked))
          .reduce((accumulator, currentValue) => {
            accumulator = [
              ...accumulator,
              {
                ...currentValue,
                options: currentValue.options.filter(option => option.isChecked)
              }
            ];
            return accumulator;
          }, [])
      }
    },
    setOrderInformationErrors: (state, action) => {
      state.orderInformationErrors = action.payload;
    },
    setOrderInformation: (state, action) => {
      state.orderInformation.information = action.payload
    },
    setOrderEta: (state, action) => {
      state.orderInformation.eta = action.payload;
    },
    setOrderTotal: (state, action) => {
      state.orderInformation.total = action.payload;
    },
    resetOrder: (state, action) => {
      if (action.payload === true) {
        state.orderErrors = {};
        state.orderIsProcessing = false;
        state.orderInformation = {
          ...state.orderInformation,
          attachments: {
            amazon: [],
            dropbox: []
          },
          checklist: {},
          eta: {
            etaText: '',
            etaIsExists: false
          },
          total: '',
        };
        state.orderInformationTempAmazon = [];
      }
    },
    checkAndUpdateIfUserProfileExists: (state, action) => {
      for (const prop in action.payload) {
        if (state.orderInformation.information[prop] !== undefined) {
          state.orderInformation.information[prop] = action.payload[prop];
          state.orderInformationIsDisabled[prop] = !!action.payload[prop];
        }
      }
    },
    checkAndUpdateIfOrderExists: (state, action) => {
      state.orderInformation = {
        ...state.orderInformation,
        ...action.payload.orderInformation
      };
      state.orderInformationTempAmazon = action.payload.orderInformationTempAmazon;
    }
  },
  extraReducers: {
    [sendOrder.pending]: (state) => {
      state.orderErrors.message = null;
      state.orderErrors.error = null;
      state.orderIsProcessing = true;
    },
    [sendOrder.fulfilled]: (state, action) => {
      if (action.payload?.error !== undefined) {
        if (action.payload?.error === true) {
          state.orderErrors.message = action.payload.message;
          state.orderErrors.error = action.payload.error;
          state.orderIsProcessing = false;
        }
        if (action.payload?.error === false && action.payload.redirect) {
          window.location.href = action.payload.redirect;
        }
      }
    },
    [sendOrder.rejected]: (state) => {
      state.orderErrors.message = 'Internal server error'
      state.orderErrors.error = true;
      state.orderIsProcessing = false;
    }
  }
});

export const {
  setOrderAttachmentsAmazon,
  setOrderChecklist,
  setOrderInformation,
  setOrderInformationErrors,
  setOrderEta,
  setOrderTotal,
  resetOrder,
  createFilesDropbox,
  deleteFileDropboxByHash,
  checkAndUpdateIfUserProfileExists,
  checkAndUpdateIfOrderExists,
  deleteFileAmazonByHash,
} = orderSlice.actions;

export default orderSlice.reducer;
